import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {updatePassword} from '../pages/AdminPages/AllCellCastUser/UserListSlice/UserListSlice'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {resetPasswordValid} from '../Utils/_helpers/ValidationSchema'

const RestPasswordPopup = ({show, handleClose, Message, Confirm, checklist, data}: any) => {
  const dispatch = useDispatch()
  const [passwordType, setPasswordType] = useState({
    password: true,
    confirm: true,
  })

  useEffect(() => {
    setPasswordType({
      password: true,
      confirm: true,
    })
  }, [show])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Reset Password</h2>
        </div>
        <div className='modal-body p-20 '>
          <Formik
            initialValues={{
              password: '',
              confirmPassword: '',
            }}
            validationSchema={resetPasswordValid}
            onSubmit={(val: any, {setSubmitting}) => {
              setSubmitting(false)
              dispatch(
                updatePassword({
                  userId: data?._id,
                  password: val.password,
                })
              )
              handleClose()
            }}
          >
            {({isSubmitting}) => (
              <Form>
                <div>
                  <label htmlFor='password'>Password</label>
                  <div className='password-wrap'>
                    <Field
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      type={passwordType.password ? 'password' : 'text'}
                      id='password'
                      name='password'
                    />
                    <span
                      className='svg-icon svg-icon-3'
                      onClick={() => {
                        setPasswordType({...passwordType, password: !passwordType.password})
                      }}
                    >
                      {passwordType.password ? (
                        <i className='bi bi-eye-fill'></i>
                      ) : (
                        <i className='bi bi-eye-slash-fill'></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage name='password'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                <div className='my-5'>
                  <label htmlFor='confirmPassword'>Confirm Password</label>
                  <div className='password-wrap'>
                    <Field
                      className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                      type={passwordType.confirm ? 'password' : 'text'}
                      id='confirmPassword'
                      name='confirmPassword'
                    />
                    <span
                      className='svg-icon svg-icon-3'
                      onClick={() => {
                        setPasswordType({...passwordType, confirm: !passwordType.confirm})
                      }}
                    >
                      {passwordType.confirm ? (
                        <i className='bi bi-eye-fill'></i>
                      ) : (
                        <i className='bi bi-eye-slash-fill'></i>
                      )}
                    </span>
                  </div>
                  <ErrorMessage name='confirmPassword'>
                    {(msg: string) => <span className='text-danger'>{msg}</span>}
                  </ErrorMessage>
                </div>
                <button className='btn btn-primary'>Reset Password</button>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default React.memo(RestPasswordPopup)
